import { Component, OnInit } from '@angular/core';
import { ActiveModal } from '@healthcatalyst/cashmere';
import { timer } from 'rxjs';
import BaseComponent from 'src/app/shared/components/base.component';

@Component({
    selector: 'cdp-idle-user-sign-out-modal',
    templateUrl: './idle-user-sign-out-modal.component.html',
    styleUrls: ['./idle-user-sign-out-modal.component.scss'],
    standalone: false
})
export class IdleUserSignOutModalComponent extends BaseComponent implements OnInit {
    timer: any;

    countdownDisplay!: number;

    tick = 1000;
    earlyTimeoutElapsedInMs = 500;

    constructor(private activeModal: ActiveModal) {
        super();
    }

    ngOnInit(): void {
        const timeoutInMs = this.activeModal.data;
        this.countdownDisplay = timeoutInMs / 1000;

        timer(0, this.tick)
            .pipe(this.unsubscribeOnDestroy())
            .subscribe(() => --this.countdownDisplay);
        this.timer = setTimeout(() => this.onSignOut(), timeoutInMs - this.earlyTimeoutElapsedInMs);
    }

    onSignOut(): void {
        clearTimeout(this.timer);
        this.activeModal.close(true);
    }

    onContinueSession(): void {
        clearTimeout(this.timer);
        this.activeModal.close(false);
    }
}
